"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const simpleUndirectedEdge_1 = require("./simpleUndirectedEdge");
const treeGrid_1 = require("../../lib/tree/treeGrid");
class SimpleUndirectedTreeEdge extends simpleUndirectedEdge_1.SimpleUndirectedEdge {
    draw(ctx, grid) {
        if (grid instanceof treeGrid_1.TreeGrid) {
            let nodeWidth = grid.getNodeWidth();
            let nodeHeight = grid.getNodeHeight();
            let fromCoord = grid.getCoordinate(this.startNode);
            let toCoord = grid.getCoordinate(this.endNode);
            ctx.beginPath();
            if (this.color != this.standardColor) {
                ctx.lineWidth = 3;
            }
            ctx.moveTo(fromCoord[1] + nodeWidth / 2, fromCoord[0] + nodeHeight);
            ctx.lineTo(toCoord[1] + nodeWidth / 2, toCoord[0]);
            ctx.strokeStyle = this.color;
            ctx.stroke();
            ctx.closePath();
        }
    }
}
exports.SimpleUndirectedTreeEdge = SimpleUndirectedTreeEdge;
